import NewAgreementFirstPage from './NewAgreementFirstPage';

export default NewAgreementFirstPage;
